module.exports = __webpack_public_path__ + "img/certificate_preview.d704b872.jpg";